<template>
    <div>
        <div class="">
            <div class="row ">
                <div class="col-md-12 table-responsive">
                    <div class="row  justify-content-start">
                        <div class="col-md-4">
                            <input
                                type="text"
                                placeholder="Müşteri Kodu"
                                class="form-control form-control-sm"
                                v-model="search.customerCode"
                            />
                        </div>
                        <div class="col-md-3">
                            <button class="btn btn-info btn-sm" @click="pagination">
                                <i class="fas fa-search"></i> Filtrele
                            </button>
                            <button class="btn btn-danger btn-sm" @click="reset">
                                <i class="fas fa-times-circle"></i>
                            </button>
                        </div>
                        <div class="col-md-5">
                            <button
                                class="btn btn-danger btn-sm float-right ml-1"
                                @click="getModalVIP(false)"
                            >Toplu Müşteri Sil</button>
                            <button
                                class="btn btn-primary btn-sm float-right"
                                @click="getModalVIP(true)"
                            >Toplu Müşteri Ekle</button>
                        </div>
                    </div>
                    <br>
                    <table class="table table-sm table-striped">
                        <thead>
                            <tr>
                                <th style="width:10%">#</th>
                                <th>Müşteri Kod</th>
                                <th>Eklenme Zamanı</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(customer,index) in customers" :key="customer.customerID">
                                <td>{{ ++index + (page - 1) * count }}</td>
                                <td>{{ customer.customerCode }}</td>
                                <td>{{ customer.addDate | DateFormat}}</td>
                                <td>
                                    <button
                                        class="btn btn-danger btn-sm"
                                        @click="deleteCustomer(customer.customerID)"
                                    >
                                        <i class="fas fa-trash"></i>
                                    </button>
                                </td>
                            </tr>
                            <tr>
                                <td
                                    v-if="customers.length == 0"
                                    colspan="4"
                                    class="text-center"
                                >Kayıt bulunamadı</td>
                            </tr>
                        </tbody>
                    </table>
                    <pagination
                        v-model="page"
                        :records="rows"
                        :per-page="count"
                        @paginate="pagination"
                    />
                </div>
            </div>
        </div>
        <div class="modal fade" id="modal-vipCustomers">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Toplu Müşteri {{ isAdd ? 'Ekle' : 'Sil'}}</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent>
                            <div class="row">
                                <div class="form-group col-md-12">
                                    <span>
                                        <strong>Müşteri Kodları</strong>
                                        <small
                                            class="text-danger font-italic"
                                        >(*Müşteri kodlarını aralarında virgül olacak şekilde yazınız)</small>
                                    </span>
                                    <textarea
                                        @blur="$v.bonus.customerCodes.$touch()"
                                        v-model="$v.bonus.customerCodes.$model"
                                        type="time"
                                        class="form-control"
                                        :class="{ 'is-invalid': $v.bonus.customerCodes.$error }"
                                    />
                                    <small
                                        v-if="!$v.bonus.customerCodes.required && $v.bonus.customerCodes.$error"
                                        class="form-text text-danger"
                                    >Bu alan zorunludur...</small>
                                </div>
                                <div class="col-md-12"></div>
                            </div>
                        </form>
                    </div>

                    <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-default" data-dismiss="modal">İptal</button>
                        <button
                            v-if="isAdd"
                            type="button"
                            class="btn btn-primary"
                            @click="saveCustomers()"
                            :disabled="$v.bonus.$invalid"
                        >                        
                            <i class="fas fa-save"></i> Bonus Müşteri Kaydet
                        </button>
                         <button
                            v-if="!isAdd"
                            type="button"
                            class="btn btn-danger"
                            @click="bulkDeleteCustomers()"
                            :disabled="$v.bonus.$invalid"
                        >                        
                            <i class="fas fa-save"></i> Toplu Müşteri Sil
                        </button>
                    </div>
                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>
    </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";

export default {
    data() {
        return {
            overlay:false,
            customers: [],
            page: 1,
            count: 10,
            rows: 0,
            search: {
                customerCode: ""
            },
            isAdd:false,
            bonus: {
                kampanya: this.$route.params.id,
                customerCodes: ""
            }
        }
    },
    validations: {
        bonus: {
            customerCodes: {
                required
            },
        }
    },
    filters: {
       DateFormat(value) {
        if (!value) return "Giriş Yapılmamış";

        let date = value.split("T")[0].split("-");
        let time = value.split("T")[1].split(".")[0];
        return date[2] + "/" + date[1] + "/" + date[0] + " " + time;
    },

    },
    methods: {
        getCustomerForBonus(type = false) {
            if (!type) this.overlay = true;
            this.$http.post("Bonus/ListVipCustomerBonus", {
                kampanyaID: this.$route.params.id,
                customerCode: this.search.customerCode,
                rowNumber: type,
                page: this.page - 1,
            }).then((response) => {
                if (type) this.rows = response.data;
                else {
                    this.customers = response.data;                   
                    this.overlay = false;
                }
            });
        },
        pagination() {
            this.getCustomerForBonus();
            this.getCustomerForBonus(true);
        },
        reset() {
            this.page = 1;
            this.search = {
                customerCode: "",
            };
            this.getCustomerForBonus();
            this.getCustomerForBonus(true);
        },
        deleteCustomer(customerId) {
            //**tablodan tek kayıt silme */
            Swal.fire({
                title:
                    "Kayıt kalıcı olarak silinecek!Onaylıyor musunuz?",
                showCancelButton: true,
                confirmButtonText: "Evet! Silinsin",
                cancelButtonText: "İptal",
                icon: "question",
            }).then((result) => {
                if (result.isConfirmed) {
                    this.overlay = true;
                    this.$http.get(`Bonus/DeleteVipCustomerBonus?kampanyaID=${this.$route.params.id}&customerId=${customerId}`).then((response) => {
                        toastr.success("Kayıt Silindi.");
                        this.search.customerCode = "";
                        this.getCustomerForBonus();
                        this.getCustomerForBonus(true);
                        this.overlay = false;
                    });
                }
            });

        },
        getModalVIP(bool) {    
            //**ekle ve sil modalı tru ve false a göre butonları ayarla */       
            if (bool) {
                this.isAdd=true;               
            }else{
                this.isAdd=false;
            }
              $('#modal-vipCustomers').modal('show');
        },
        saveCustomers() {
            //**toplu kullanıcı ekle */
            this.$http.post("Bonus/AddVipCustomerBonus", this.bonus).then((response) => {
                 this.getCustomerForBonus();
                this.getCustomerForBonus(true);
                this.bonus.customerCodes = "";
                toastr.success("Kayıt başarılı.");
                 $('#modal-vipCustomers').modal('hide');
            }, (err) => {
                toastr.error(err.data.Message);
            });
        },
        bulkDeleteCustomers(){
            //**toplu kullanıcı sil */
             Swal.fire({
                title:
                    "Liste kalıcı olarak silinecek!Onaylıyor musunuz?",
                showCancelButton: true,
                confirmButtonText: "Evet! Silinsin",
                cancelButtonText: "İptal",
                icon: "question",
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$http.post("Bonus/DeleteVipCustomerBonus", this.bonus).then((response) => {
                        this.getCustomerForBonus();
                        this.getCustomerForBonus(true);
                        this.bonus.customerCodes = "";
                        toastr.success("İşlem başarılı.");
                        $('#modal-vipCustomers').modal('hide');
                    }, (err) => {
                        toastr.error(err.data.Message);
                    });
                }
            });

        }
    },
    created(){
        this.getCustomerForBonus();
        this.getCustomerForBonus(true);
    }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/BonusList/BonusTabs/CustomerConnections.vue